import common from './common.json';
import home from './home.json';
import tutorial from './tutorial.json';
import nav from './nav.json';
import settings from './settings.json';
import auth from './auth.json';
import consent from './consent.json';
import legal from './legal.json';
import notify from './notify.json';
import game from './game.json';
import play from './play.json';
import word from './word.json';
import feedback from './feedback.json';
import leaderboard from './leaderboard.json';
import rank from './rank.json';
import store from './store.json';
import streak from './streak.json';
import ads from './ads.json';
import errors from './errors.json';

const catalog = { common, home, tutorial, nav, settings, auth, consent, legal, notify, game, play, word, feedback, leaderboard, rank, store, streak, ads, errors };

export default catalog;
